//Use this as a template.
import { resource, Entity, repository } from 'aurelia-orm';

@resource("AppState")//An error message: 'Unable to find resource for entity' will be thrown if the resource decoroator is not used.
export class AppState extends Entity {
	id: number;
	appUserId: number;
	objectName: string;
	propertyName: string;
	value: string;
	isObject: boolean;
}